import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import UpgradeToNbnForm from '../forms/UpgradeToNbnForm'
import globals from '../globals'
import MigrateMobileForm from '../forms/MigrateMobileForm'
import { getCustomer } from '../redux/actions'
import { connect } from 'react-redux'
import FormHOC from '../forms/FormHOC'

class MigrateMobileModule extends React.Component {
    componentDidMount () {

    }

    handleSuccess (response, state) {
	    // todo: Add event
        // globals.pushEvent('UpgradeToNbn', {speed: state.speed, allowance: state.allowance});
        this.props.getCustomer()
    }

    render () {
        return (
            <div className='module' style={{ overflow: 'visible' }}>
                <div id='sub-navigation' />{/* This is for scrollToNav method in FormHOC */}
                <Heading title='Migrate my mobile' />
                <ModuleWithLoader isLoaded={this.props.isLoaded} hasError={this.props.hasError} className='p-4'>
                    <div className='row mb-4'>
                        <div className='col-12 col-lg-10 offset-lg-1 text-center'>
                            <h1 className='m-0 mb-2'>Migrating your mobile service is easy</h1>
                            <p className='font-small m-0 mb-2'>(you will keep your mobile number)</p>
                            <p className='m-0 lh'><span className='bold'>Choose your new ExeSIM mobile plan below.</span> We’ll then send you a new SIM via Australia Post which you can activate in My Exetel. Once your new service activates we’ll also credit any unused component of your monthly fee from your old plan to your new account. It’s that simple!</p>
                        </div>
                    </div>
                    <MigrateMobileForm
                        numbers={this.props.numbers}
                        handleSuccess={this.handleSuccess.bind(this)}
                    />
                </ModuleWithLoader>
            </div>
        )
    }
}

MigrateMobileModule.propTypes = {
    isLoaded: PropTypes.bool.isRequired,
    hasError: PropTypes.bool.isRequired,
    numbers: PropTypes.array.isRequired
}

const mapStateToProps = state => ({

})

export default connect(mapStateToProps, { getCustomer })(MigrateMobileModule)



// WEBPACK FOOTER //
// ./resources/js/modules/MigrateMobileModule.js